import { Component, EventEmitter, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { OrderByPipe } from '@wm/components-base';
import { WmsFeatureDirective } from '@wms/directives';
import { BaseComponent, SearchComponent, WmsTreeComponent, WmsDialogComponent, WmsDialogHeaderComponent, WmsDialogBodyComponent, WmsDialogFooterComponent } from '@wms/components';
import { getServiceTypesByCollectionType, AddVariableConfigComponent, BaseVariableService, VariableCrudManagerService } from '@wms/variables';
import { map, forEach, findIndex} from 'lodash-es';
import { BindTreeUtilsService, BindVariableService, DialogService } from '@wms/services';
import { Subscription } from 'rxjs';
import { BindVariableTreeComponent } from '@wms/components';
import { PageSelectComponent } from "@wms/app/components/bind-dialog/page-select/page-select.component";

@Component({
  selector: 'wms-bind-variable',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TabsModule,
    SearchComponent,
    OrderByPipe,
    WmsTreeComponent,
    WmsFeatureDirective,
    WmsDialogComponent,
    WmsDialogHeaderComponent,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    AddVariableConfigComponent,
    BindVariableTreeComponent,
    PageSelectComponent
  ],
  templateUrl: './bind-variable.component.html',
  styleUrls: ['./bind-variable.component.less']
})
export class BindVariableComponent extends BaseComponent implements OnInit {
  @Output() reloadVarTree = new EventEmitter<any>();
  variableSearchKey: any;
  variableCategoryFilter: any;
  message: any;
  typeVariablesNotFound: any;
  bindVariableService: BindVariableService;
  bindTreeService: BindTreeUtilsService;
  dialogService: DialogService;
  variableService: BaseVariableService;
  variableManagerService: VariableCrudManagerService;
  reloadVarSubscription: Subscription;

  constructor() {
    super();
    this.bindVariableService = inject(BindVariableService);
    this.bindTreeService = inject(BindTreeUtilsService);
    this.dialogService = inject(DialogService);
    this.variableService = inject(BaseVariableService);
    this.variableManagerService  = inject(VariableCrudManagerService);
    this.bindVariableService.variableCategoryList = getServiceTypesByCollectionType('data');
    this.bindVariableService.variableCategoryList.push('all');
    this.bindVariableService.variableCategoryList = map(this.bindVariableService.variableCategoryList, (value) => {
      return {
        'key': value,
        'value': value,
        'label': this.locale.LABEL_VARIABLE_SERVICETYPE[value]
      };
    });
    /* default category filter for variable list */
    this.variableCategoryFilter = this.bindVariableService.variableCategoryList[this.bindVariableService.variableCategoryList.length - 1].key;
    this.reloadVarSubscription = this.variableService.reloadVariablesObs().subscribe((isVarDialog: boolean) => {
      this.reloadVarTree.emit();
      this.closeDialogWithId('bindingAddVariableModal');
    });
  }

  openDialogWithId(id: string): void {
    this.dialogService.open(id);
  }

  /* filtering variable category based on selected variable category list*/
  onVariableTypeChange(type: any) {
    this.bindVariableService.filteredVariablesTree = [];
    this.typeVariablesNotFound = false;
    if (type === 'all') {
      this.bindVariableService.filteredVariablesTree = this.bindVariableService.variablesTree;
    } else {
      this.bindVariableService.filteredVariablesTree = this.bindTreeService.getRootStructure();
      forEach(this.bindVariableService.variablesTree, (child: any) => {
        let index = findIndex(this.bindVariableService.filteredVariablesTree, { id: child.id });//Get index of current child
        forEach(child.children, (typeNode: any) => {
          if (typeNode.id === type) {
            this.bindVariableService.filteredVariablesTree[index].children.push(typeNode);
          }
        });
      });
      this.bindVariableService.filteredVariablesTree = this.getRootNodesWithChildren(this.bindVariableService.filteredVariablesTree);
    }
    if (this.bindVariableService.isTreeEmpty(this.bindVariableService.filteredVariablesTree)) {
      this.typeVariablesNotFound = true;
      this.message = this.locale.LABEL_TYPE_VARIABLES_NOT_FOUND.replace("${0}", type);
    }
  }

  /**
   *removes the objects from the variablesTree if the parent node doesn't carries any child nodes
   * @param value
   */
  getRootNodesWithChildren(treeNode: any) {
    let tree: any = [];
    forEach(treeNode, function (item) {
      if (item.children.length) {
        tree.push(item);
      }
    });
    return tree;
  }

  searchVariable($event: any) {
    this.variableSearchKey = $event.searchKey;
  }

  closeDialogWithId(id: string): void {
    this.dialogService.close(id);
  }

  getBindDialogEl() {
    this.bindVariableService.dialogParams.addCustomClass = undefined;
    return $(document).find('.bind-variable-dialog');
  }

  ngOnInit(): void {
    if (!this.bindVariableService.isVariablesLoaded) {
      (this.bindVariableService as any).fetchVariables(false);
    }
    this.variableService.initServiceTypesList('data');
    this.variableManagerService.initVariablePropertyList();
  }
}


